export default () => window.innerWidth < 578;
